import { 
  Cpu, Heart, FlaskConical, Leaf, Building2, Banknote, 
  Briefcase, Shield, Scale, Palette, Anchor, Train
} from 'lucide-react';

// Consistent exam icon mapping across the app
export const examIconMap = {
  'JEE Main': Cpu,
  'JEE Advanced': Cpu,
  'GATE': Cpu,
  'BITSAT': Cpu,
  'VITEEE': Cpu,
  'NEET UG': Heart,
  'AIIMS': Heart,
  'JIPMER': Heart,
  'CUET': Heart,
  'AFMC': Heart,
  'UPSC': Building2,
  'SSC CGL': Building2,
  'RRB NTPC': Train,
  'CAT': Briefcase,
  'IBPS': Banknote,
  'NDA': Shield,
  'CDS': Shield,
  'CLAT': Scale,
  'NIFT': Palette,
  'NID': Palette,
  'NATA': Palette,
  'NEST': FlaskConical,
  'IAT': FlaskConical,
  'IMU CET': Anchor,
};

// Get icon component for an exam
export const getExamIcon = (examName) => {
  return examIconMap[examName] || FlaskConical;
};

// Render exam icon with standard styling
export const ExamIconComponent = ({ examName, size = 20, className = '' }) => {
  const IconComp = getExamIcon(examName);
  return <IconComp size={size} className={className} />;
};
